// extracted by mini-css-extract-plugin
module.exports = {"title":"Actualites_title__3NMCw","buttonWrapper":"Actualites_buttonWrapper__Vq7aL"};